/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PreferenceRule,
    PreferenceRuleFromJSON,
    PreferenceRuleFromJSONTyped,
    PreferenceRuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface PreferenceRuleListBusinessDataResponse
 */
export interface PreferenceRuleListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof PreferenceRuleListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<PreferenceRule>}
     * @memberof PreferenceRuleListBusinessDataResponse
     */
    businessData?: Array<PreferenceRule> | null;
    /**
     * 
     * @type {number}
     * @memberof PreferenceRuleListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PreferenceRuleListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PreferenceRuleListBusinessDataResponse
     */
    totalRecords?: number;
}

export function PreferenceRuleListBusinessDataResponseFromJSON(json: any): PreferenceRuleListBusinessDataResponse {
    return PreferenceRuleListBusinessDataResponseFromJSONTyped(json, false);
}

export function PreferenceRuleListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferenceRuleListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(PreferenceRuleFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function PreferenceRuleListBusinessDataResponseToJSON(value?: PreferenceRuleListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(PreferenceRuleToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


